import { word } from "@/modules/core/utils/i18n"

export enum CoachActivityTypeEnum {
  WELLNESS = "WELLNESS",
  PRE_POSTNATAL_COACHING = "PRE_POSTNATAL_COACHING",
  SENIOR_COACHING = "SENIOR_COACHING",
  CROSSFIT = "CROSSFIT",
  CYCLING = "CYCLING",
  FUNCTIONAL_TRAINING = "FUNCTIONAL_TRAINING",
  FITNESS = "FITNESS",
  HYROX = "HYROX",
  MOBILITY_STRETCHING = "MOBILITY_STRETCHING",
  STRENGTH_TRAINING = "STRENGTH_TRAINING",
  SWIMMING = "SWIMMING",
  NUTRITION = "NUTRITION",
  PILATES = "PILATES",
  MENTAL_PREPARATION = "MENTAL_PREPARATION",
  ATHLETIC_PREPARATION = "ATHLETIC_PREPARATION",
  RETURN_TO_SPORT = "RETURN_TO_SPORT",
  RUNNING = "RUNNING",
  HEALTH_FITNESS = "HEALTH_FITNESS",
  TEAM_SPORTS = "TEAM_SPORTS",
  COMBAT_SPORTS = "COMBAT_SPORTS",
  TRAIL_RUNNING = "TRAIL_RUNNING",
  TRIATHLON = "TRIATHLON",
  YOGA = "YOGA",
  OTHER = "OTHER",
}

// Predefined activities for the Select (OTHER excluded — used for free-text entries)
export const AVAILABLE_COACH_ACTIVITY_TYPES: CoachActivityTypeEnum[] = [
  CoachActivityTypeEnum.WELLNESS,
  CoachActivityTypeEnum.PRE_POSTNATAL_COACHING,
  CoachActivityTypeEnum.SENIOR_COACHING,
  CoachActivityTypeEnum.CROSSFIT,
  CoachActivityTypeEnum.CYCLING,
  CoachActivityTypeEnum.FUNCTIONAL_TRAINING,
  CoachActivityTypeEnum.FITNESS,
  CoachActivityTypeEnum.HYROX,
  CoachActivityTypeEnum.MOBILITY_STRETCHING,
  CoachActivityTypeEnum.STRENGTH_TRAINING,
  CoachActivityTypeEnum.SWIMMING,
  CoachActivityTypeEnum.NUTRITION,
  CoachActivityTypeEnum.PILATES,
  CoachActivityTypeEnum.MENTAL_PREPARATION,
  CoachActivityTypeEnum.ATHLETIC_PREPARATION,
  CoachActivityTypeEnum.RETURN_TO_SPORT,
  CoachActivityTypeEnum.RUNNING,
  CoachActivityTypeEnum.HEALTH_FITNESS,
  CoachActivityTypeEnum.TEAM_SPORTS,
  CoachActivityTypeEnum.COMBAT_SPORTS,
  CoachActivityTypeEnum.TRAIL_RUNNING,
  CoachActivityTypeEnum.TRIATHLON,
  CoachActivityTypeEnum.YOGA,
]

export const getCoachActivitiesSortedByLabel = (locale: string) => {
  return [...AVAILABLE_COACH_ACTIVITY_TYPES].sort((a, b) =>
    word(`coach.activity.${a}`).localeCompare(word(`coach.activity.${b}`), locale),
  )
}
